import PropTypes from "prop-types";
import React from "react";
import CSSModules from "react-css-modules";
import { FormattedMessage } from "react-intl";
import styles from "./debitCardForm.scss";

const CARD_NUMBER_LENGTH = 16;
const SEGMENT_LENGTH = 4;
const KEY_0 = 48;
const KEY_9 = 57;

const segmentRegex = new RegExp("^\\d{0," + SEGMENT_LENGTH + "}$");

class CardNumberInput extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      cardNumberPart1: "",
      cardNumberPart2: "",
      cardNumberPart3: "",
      cardNumberPart4: ""
    };
  }

  handleKeyPress = e => {
    e.preventDefault();
    const { target: elem, key } = e;
    const { selectionStart, value } = elem;

    if (!segmentRegex.test(value)) {
      return;
    }

    //validate
    if (!/\d/.test(key) || selectionStart >= SEGMENT_LENGTH) {
      return;
    }

    const valueArr = value.split("");
    valueArr[selectionStart] = key;
    elem.value = valueArr.join("");
    elem.selectionStart = selectionStart + 1;
    elem.selectionEnd = selectionStart + 1;
    this.handleOnChangeEvent(e);
  };

  handleOnChangeEvent = e => {
    const { target: elem } = e;
    const { value, name } = elem;
    const updateOnChange = () => {
      if (this.props.onChange) {
        const cardNumber = [
          this.state.cardNumberPart1,
          this.state.cardNumberPart2,
          this.state.cardNumberPart3,
          this.state.cardNumberPart4
        ].join("");
        this.props.onChange(
          cardNumber.length === CARD_NUMBER_LENGTH ? cardNumber : "",
          this.props.name
        );
      }
    };

    //handle autofill
    if (value.length === CARD_NUMBER_LENGTH) {
      this.setState(
        () => ({
          cardNumberPart1: value.substring(0, 4),
          cardNumberPart2: value.substring(4, 8),
          cardNumberPart3: value.substring(8, 12),
          cardNumberPart4: value.substring(12, 16)
        }),
        updateOnChange
      );
    } else {
      this.setState(() => ({ [name]: value }), updateOnChange);
    }
  };

  handleInputFocusBackward = e => {
    const { target: elem, key } = e;
    const { selectionStart, previousSibling } = elem;
    if (
      selectionStart === 0 &&
      ["Backspace", "ArrowLeft"].indexOf(key) >= 0 &&
      previousSibling
    ) {
      setTimeout(() => previousSibling.focus());
    }
  };

  handleInputFocusForward = e => {
    const { target: elem, key: eventKey, which } = e;
    const { selectionStart, nextSibling } = elem;
    let key = eventKey;
    if (
      (!eventKey || eventKey === "Unidentified") &&
      which >= KEY_0 &&
      which <= KEY_9
    ) {
      key = which - KEY_0;
    }
    if (
      selectionStart === SEGMENT_LENGTH &&
      /(\d)|(ArrowRight)/.test(key) &&
      nextSibling
    ) {
      nextSibling.focus();
    }
  };

  render() {
    const inputSegments = new Array(4).fill(null).map((_value, index) => {
      const name = "cardNumberPart" + (index + 1);
      return (
        <input
          data-at={`${name}`}
          key={name}
          name={name}
          value={this.state[name]}
          onChange={this.handleOnChangeEvent}
          onKeyDown={this.handleInputFocusBackward}
          onKeyUp={this.handleInputFocusForward}
          onKeyPress={this.handleKeyPress}
          type="text"
          pattern="[0-9]*"
        />
      );
    });

    return (
      <div styleName="inputGroupColumn">
        <label>
          <FormattedMessage id="updateDebitCard.form.cardNumber" />
        </label>
        <div styleName="cardNumberInput">{inputSegments}</div>
      </div>
    );
  }
}

export default CSSModules(styles, { allowMultiple: true })(CardNumberInput);



// WEBPACK FOOTER //
// ./src/components/common/debitCardForm/CardNumberInput.js